// @ts-nocheck
// główny layout - górna belka nagłówka

import React, { ReactElement } from "react";
import { Trans, useTranslation } from "react-i18next";
import { BoxArrowRight } from "react-bootstrap-icons";
import classnames from "classnames";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Gear } from "react-bootstrap-icons";
import qs from "query-string";

import { useAppNavigate } from "hooks";
import { usePostOverLogout, useGetLayoutUrlResolverToLanguage } from "api";
import { useDispatch, reduxActions, useSelector } from "store";
import { Container, DropDown, OverLoginUsers, Link } from "components/controls";
import Trader from "components/layouts/MainLayout/components/HeaderTopBar/components/Trader";

import { ReactComponent as FlagPL } from "assets/flags/pl.svg";
import { ReactComponent as FlagEN } from "assets/flags/gb.svg";

import styles from "theme/components/layouts/MainLayout/components/HeaderTopBar/HeaderTopBar.module.scss";
import LoginButton from "components/containers/LoginButton";
import Tooltip from "@mui/material/Tooltip";

const HeaderTopBar = ({
  isAdminPanel,
  simpleHeader,
}: {
  isAdminPanel?: boolean;
  simpleHeader?: boolean;
}) => {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const { profile, overloginUserId } = useSelector((state) => state.auth);
  const { search } = useLocation();
  const navigate = useAppNavigate();

  // pobranie url_key po zmianie języka
  const { mutateAsync: refetchUrlResolverToLanguage } =
    useGetLayoutUrlResolverToLanguage({
      onSuccess: (data) => {
        const params = {
          ...qs.parse(search),
          ...qs.parse(data.parameters),
        };

        navigate(`/${data.url_shortcut}?${qs.stringify(params)}`, {
          replace: true,
        });
      },
    });

  const { mutateAsync } = usePostOverLogout();

  // wylogowanie uźytkownika z systemu
  const handleLogout = async () => {
    if (overloginUserId) {
      // zawsze po przełączeniu użytkownika wracamy na stronę główną
      navigate("/", { replace: true });
      await mutateAsync();

      dispatch(reduxActions.setCurrentCartId(null));
      dispatch(reduxActions.setOverlogin(null));

      return;
    }
    dispatch(reduxActions.signOut());
  };

  // flagi języków
  const flags: Record<string, ReactElement> = {
    en: <FlagEN />,
    pl: <FlagPL />,
  };

  const renderAdminPanelButton = () => {
    if (isAdminPanel) {
      return (
        <Link className={styles.link} to="/">
          <BoxArrowRight />
          <Trans>Wróć do sklepu</Trans>
        </Link>
      );
    }

    if (profile?.role === "ROLE_ADMIN") {
      return (
        <Link className={styles.link} to="/managment_panel">
          <Gear />
          <Trans>Panel administratora</Trans>
        </Link>
      );
    }

    return null;
  };

  const renderContent = () => {
    return (
      <div className={styles.topBar}>
        <div>
          <span className={styles.user}>
            {t("Zalogowany jako")}{" "}
            {profile?.id !== profile?.logged_user?.id ? (
              <Tooltip
                className={styles.overloginTooltip}
                TransitionProps={{
                  style: {
                    background: "#fff",
                    borderRadius: 0,
                    border: "1px solid #4917C7",
                  },
                }}
                title={
                  <div className={styles.overloginTooltip}>
                    <div>
                      <span>
                        <Trans>Użytkownik zalogowany</Trans>:{" "}
                        {profile?.logged_user?.first_name}{" "}
                        {profile?.logged_user?.last_name}
                      </span>
                    </div>
                    <div>
                      <span>
                        <Trans>Rola</Trans>: {profile?.logged_user?.role}
                      </span>
                    </div>
                  </div>
                }
              >
                <strong
                  className={classnames({
                    [styles.overlogin]: true,
                  })}
                >
                  {profile?.first_name} {profile?.last_name}
                </strong>
              </Tooltip>
            ) : (
              <strong>
                {profile?.first_name} {profile?.last_name}
              </strong>
            )}
          </span>
        </div>
        <div>
          {renderAdminPanelButton()}

          {profile?.role !== "ROLE_OPEN_PROFILE" ? (
            <>
              {!overloginUserId &&
                ["ROLE_ADMIN", "ROLE_TRADER"].includes(profile?.role) && (
                  <OverLoginUsers />
                )}
            </>
          ) : (
            <LoginButton />
          )}
        </div>
      </div>
    );
  };

  if (
    !profile || //
    !(["ROLE_ADMIN", "ROLE_TRADER"].includes(profile?.role) || overloginUserId)
  ) {
    return (
      <Helmet>
        {/* INHB-929: canonical bez parametrów zapytania */}
        <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
      </Helmet>
    );
  }

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        "StylePath-Components-Layouts-MainLayout-Components-HeaderTopBar"
      )}
    >
      <Helmet>
        {/* INHB-929: canonical bez parametrów zapytania */}
        <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
      </Helmet>
      <Container>{renderContent()}</Container>
    </div>
  );
};

export default HeaderTopBar;
